<template>
    <div>
        <div style="background-color: #1E1E1E; display: flex; justify-content: space-between; align-items: center" class="flex-min">
          <div style="flex-grow: 1; padding-left: 15px">
            <v-tabs
                dark
                v-model="tab"
            >
              <v-tab>Map</v-tab>
              <v-tab>Calendar</v-tab>
            </v-tabs>
          </div>
          <div style="background-color: #1E1E1E; color: #fff!important; line-height: 1.5; padding-top: 5px; padding-bottom: 5px; padding-right: 15px">
            <span class="badge ml-2" :class="getRateColor(market['KOSPI'].rate)">{{market['KOSPI'].label}} {{market['KOSPI'].rate}}</span>
            <span class="badge ml-2" :class="getRateColor(market['KOSDAQ'].rate)">{{market['KOSDAQ'].label}} {{market['KOSDAQ'].rate}}</span>
            <span class="badge ml-2" :class="getRateColor(market['DJI'].rate)">{{market['DJI'].label}} {{market['DJI'].rate}}</span>
            <span class="badge ml-2" :class="getRateColor(market['NAI'].rate)">{{market['NAI'].label}} {{market['NAI'].rate}}</span>
            <span class="badge ml-2" :class="getRateColor(market['SHS'].rate)">{{market['SHS'].label}} {{market['SHS'].rate}}</span>
            <span class="badge badge-sort ml-2" style="cursor: pointer" v-on:click="openSortDialog">정렬</span>
            <span class="badge badge-filter ml-2" style="cursor: pointer" v-on:click="openFilterDialog">필터</span>
            <span class="badge ml-2"><a href="https://blog.naver.com/theme-lab" target="_blank">블로그</a></span>
            <span class="badge badge-success ml-2" style="cursor: pointer" v-on:click="openDialog"> <img src="click.svg" alt="후원" width="10"><span style="color: #1E1E1E">후원</span></span>
          </div>
        </div>
        <div>
          <v-expansion-panels tile dark flat>
            <v-expansion-panel>
              <v-expansion-panel-header>{{todaySchedule.title}}</v-expansion-panel-header>
              <v-expansion-panel-content style="white-space: pre-line; font-size: 14px;">
                <div v-html="todaySchedule.contents">
                </div>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>

        </div>

        <v-container fluid>
            <v-progress-linear :indeterminate="true" v-show="!loaded"></v-progress-linear>
            <v-tabs-items v-model="tab">
              <v-tab-item
                  v-for="(item, index) in tabs"
                  :key="item"
              >
                <template v-if="index === 0">
                  <v-row no-gutters>
                    <v-col cols="1">
                      <iframe width="120" height="600" allowtransparency="true" src="https://tab2.clickmon.co.kr/pop/wp_ad_120.php?PopAd=CM_M_1003067%7C%5E%7CCM_A_1132607%7C%5E%7CAdver_M_1046207&mon_rf=REFERRER_URL&mon_direct_url=URLENCODE_PASSBACK_INPUT" frameborder="0" scrolling="no"></iframe>
                    </v-col>
                    <v-col cols="10">
                      <v-data-iterator
                          :items="filterTheme"
                          :items-per-page.sync="itemsPerPage"
                          hide-default-footer
                          no-data-text=""
                      >
                        <template>
                          <v-row>
                            <v-col
                                v-for="item in filterTheme"
                                :key="item.header"
                                cols="12"
                                xs="6"
                                sm="4"
                                md="3"
                                lg="1"
                                class="theme-layout"
                            >
                              <v-card>
                                <v-card-title
                                    :class="{'each': item.type === 'each', 'covid': item.type === 'covid', 'tech1': item.type === 'tech1', 'tech2': item.type === 'tech2', 'country': item.type === 'country', 'business': item.type === 'business', 'person': item.type === 'person', 'company': item.type === 'company'}"
                                    class="header subheading font-weight-bold">
                                  <div>
                                    {{ item.hot ? '★ ' + item.header : item.header }}
                                    <v-icon
                                        v-if="comment[item.header] && comment[item.header].comment"
                                        v-on:click="getThemeComment(item.header)"
                                        small
                                        color="#ededed"
                                    >
                                      mdi-help-box
                                    </v-icon>
                                  </div>
                                  <v-chip v-if="item.avg > 0"
                                          color="red"
                                          text-color="white"
                                          small
                                  >
                                    {{ item.avg }}
                                  </v-chip>
                                  <v-chip v-else
                                          color="blue"
                                          text-color="white"
                                          small
                                  >
                                    {{ item.avg }}
                                  </v-chip>
                                  <!--
                                  <div class="header-avg" :class="{'rise2': item.avg > 0, 'down': item.avg < 0}">
                                  </div>
                                  -->
                                </v-card-title>

                                <v-divider></v-divider>

                                <v-list dense>
                                  <template v-for="(stock, index) in item.filterStocks">
                                    <template v-if="index <= 4">
                                      <stock :name="stock.name" :stock="getStockInfo(stock.name)" :comment="getStockComment(item.header, stock.name)" />
                                    </template>
                                    <template v-if="index === 5">
                                      <template v-if="item.collapse">
                                        <div style="display: flex; justify-content: center; cursor:pointer">
                                          <div @click="onChange(item, item.header, false)">
                                            <v-icon>expand_more</v-icon>
                                          </div>
                                        </div>
                                      </template>
                                      <template v-else>
                                        <stock :name="stock.name" :stock="getStockInfo(stock.name)" :comment="getStockComment(item.header, stock.name)" />
                                      </template>
                                    </template>
                                    <template v-if="index > 5 && !item.collapse">
                                      <stock :name="stock.name" :stock="getStockInfo(stock.name)" :comment="getStockComment(item.header, stock.name)" />
                                    </template>
                                  </template>
                                </v-list>
                                <template v-if="!item.collapse">
                                  <div style="display: flex; justify-content: center; cursor:pointer; padding: 0px 0px 6px 0px;">
                                    <div @click="onChange(item, item.header, true)">
                                      <v-icon>expand_less</v-icon>
                                    </div>
                                  </div>
                                </template>
                              </v-card>
                            </v-col>
                          </v-row>
                        </template>
                      </v-data-iterator>
                      <v-card
                          v-if="loaded && filterTheme.length===0"
                          class="mx-auto"
                          tile
                      >
                        <v-list-item two-line>
                          <v-list-item-content>
                            <v-list-item-title>검색 결과가 없습니다.</v-list-item-title>
                            <v-list-item-subtitle>검색어: {{filter}}, 등락률: {{filters.rate}}, 거래대금: {{filters.tradePrice}}</v-list-item-subtitle>
                          </v-list-item-content>
                        </v-list-item>
                      </v-card>
                    </v-col>
                    <v-col cols="1">
                      <iframe width="160" height="600" allowtransparency="true" src="https://tab2.clickmon.co.kr/pop/wp_ad_160.php?PopAd=CM_M_1003067%7C%5E%7CCM_A_1132607%7C%5E%7CAdver_M_1046207&mon_rf=REFERRER_URL&mon_direct_url=URLENCODE_PASSBACK_INPUT" frameborder="0" scrolling="no"></iframe>
                    </v-col>
                  </v-row>
                </template>
                <template v-if="index === 1">
                  <Calendar :calendar="calendar" :dailyRanks="dailyRanks" />
                </template>
              </v-tab-item>
            </v-tabs-items>




<!--            <v-snackbar
                v-if="loaded"
                v-model="snackbar"
                centered
                right
                tile
                color="red accent-2"
                timeout="5000"
            >
              [업데이트] 검색어 필터 오류 - 2022.1.26
            </v-snackbar>-->
        </v-container>
      <v-dialog
          v-model="showDialog"
          width="700"
          height="500"
      >
        <v-card>
          <v-card-text style="overflow: auto">
            <div style="display: flex; flex-direction: row; text-align: center; padding-top: 10px;">
              <div style="padding: 5px 5px 5px 5px">
                <div style="font-weight: bold">
                  계좌번호
                </div>
                <div style="display: flex; flex-direction: column; align-items: center; height: 100%; justify-content: center">
                  <div>
                    기업은행
                  </div>
                  <div>
                    409-128368-04-018
                  </div>
                  <div>
                    테마랩(정영철)
                  </div>
                </div>
              </div>
              <v-divider
                  class="mx-4"
                  vertical
              ></v-divider>
              <div style="padding: 5px 5px 5px 5px">
                <div style="font-weight: bold">
                  비트코인
                </div>
                <img src="btc.png" width="120px"/>
                <div style="font-size: 10px">
                  37NE1kbKewUe3XD8t5ugXnPyvarALiMrBs
                </div>
                <v-btn
                    elevation="1"
                    small
                    v-on:click="copyToClipboard('37NE1kbKewUe3XD8t5ugXnPyvarALiMrBs')"
                >
                  주소 복사
                </v-btn>
              </div>
              <v-divider
                  class="mx-4"
                  vertical
              ></v-divider>
              <div style="padding: 5px 5px 5px 5px">
                <div style="font-weight: bold">
                  이더리움
                </div>
                <img src="eth.png" width="120px"/>
                <div style="font-size: 10px">
                  0x777f86c62604bacf12767a12acd38ae152f3a7c3
                </div>
                <v-btn
                    elevation="1"
                    small
                    v-on:click="copyToClipboard('0x777f86c62604bacf12767a12acd38ae152f3a7c3')"
                >
                  주소 복사
                </v-btn>
              </div>
            </div>
          </v-card-text>

          <v-divider></v-divider>

          <div style="text-align: center; font-size: 12px; padding-top: 5px; padding-bottom: 3px;">
            <div>
              테마랩은 광고 최소로 운영하고 있습니다.
            </div>
            <div>
              최근 운영비가 급중하는 중입니다. 많은 후원 부탁드립니다. ^^.
            </div>
            <div>
              여러분의 따뜻한 후원은 사이트의 유지 관리 및 신규 콘텐츠 개발을 위해 부끄럽지 않게 사용하도록 하겠습니다.
            </div>
          </div>
        </v-card>
      </v-dialog>
      <v-dialog
          v-model="showCommentDialog"
          width="500"
          height="300"
      >
        <v-card
            class="mx-auto"
            tile
        >
          <v-toolbar
              color="#7c0a0a"
              dense
              short
              dark
          >
            <v-toolbar-title>{{headerComment}}</v-toolbar-title>
          </v-toolbar>
          <v-list dark>
            <v-subheader
                v-text="themeComment"
                style="font-size: 13px; height: 100%;"
            >
            </v-subheader>
            <div style="padding-top: 8px">
              <template v-for="(item, index) in themeStockComment">
                <v-divider
                    v-if="index != 0"
                    :key="index"
                ></v-divider>

                <v-list-item
                >
                  <v-list-item-content>
                    <v-list-item-title style="font-size: 12px; font-weight: bold" v-html="item.stock"></v-list-item-title>
                    <v-list-item-subtitle style="font-size: 12px; white-space: pre-wrap" v-html="item.comment"></v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </template>
            </div>

          </v-list>
        </v-card>
      </v-dialog>
      <v-dialog
          v-model="showSortDialog"
          max-width="250"
      >
        <v-card dark>
          <v-card-title class="header subheading font-weight-bold">
            정렬
          </v-card-title>

          <v-card-text style="padding: 0px 0px 5px 0px !important; display: flex; justify-content: center">
            <div>
              <v-chip-group
                  active-class="deep-purple accent-4 white--text"
                  column
                  v-model="sort"
              >
                <v-chip small value="rate">등락률</v-chip>
                <v-chip small value="tradePrice">거래대금</v-chip>
              </v-chip-group>
            </div>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-dialog
          v-model="showFilterDialog"
          max-width="400"
      >
        <v-card dark>
          <v-card-title class="header subheading font-weight-bold">
            필터
          </v-card-title>

          <v-card-text style="padding: 0px 0px 5px 0px !important; display: flex; flex-direction: column; justify-content: center; align-items: center">
            <div style="width: 80%;">
              <v-slider
                  v-model="filters.rate"
                  class="align-center"
                  max="30"
                  min="-30"
                  thumb-label="always"
                  thumb-color="red"
                  thumb-size="24"
                  label="등락률"
              >
                <template v-slot:append>
                  <v-text-field
                      v-model="filters.rate"
                      class="mt-0 pt-0"
                      type="number"
                      style="width: 60px"
                  ></v-text-field>
                </template>
              </v-slider>
            </div>
            <div style="width: 80%">
              <v-slider
                  v-model="filters.tradePrice"
                  class="align-center"
                  max="3000"
                  min="0"
                  thumb-label="always"
                  thumb-color="red"
                  thumb-size="24"
                  step="10"
                  ticks
                  label="거래대금(억)"
              >
                <template v-slot:append>
                  <v-text-field
                      v-model="filters.tradePrice"
                      class="mt-0 pt-0"
                      type="number"

                      style="width: 60px"
                  ></v-text-field>
                </template>
              </v-slider>
            </div>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-dialog
          v-model="showNoticeDialog"
          width="auto"
      >
        <v-card dark>
          <v-card-title class="header subheading font-weight-bold">
            Notice
          </v-card-title>
          <v-card-text>
            <div>
              안녕하세요. 테마랩 운영자입니다.
            </div>
            <div>
              약 3년의 시간 동안 본 사이트는 영리적인 목적의 이윤 추구가 아닌 순수하게 대한민국에서 주식에 대한 열정을 가진 여러분들에게 최선을 다하여 무료로 서비스를 제공해 드렸습니다.
            </div>
            <div>
              하지만 계속해서 늘어가는 방문자 수로 인해서 점점 더 운영비로 지불해야 하는 클라우드 비용이 커진 바, 급기야 최근에는 더 이상 무료로 제공하기에는 비용에 부담이 너무 큰게 사실이라 많은 고민과 갈등을 하였습니다.
            </div>
            <div>
              그래서 아래 내용으로 여러분들에게 제안을 하고자 합니다.
            </div>
            <v-timeline align-top
                        dense>
              <v-timeline-item
                  v-for="item in noticeContents"
                  :key="item.id"
                  :color="item.dotColor"
                  small
              >
                  <div v-if="item.id == '1'">
                    테마랩 사이트 후견인을 모십니다. 테마랩 사이트나 블로그 등을 통해서 많은 도움을 받으신 분들이 계시다면 <span style="font-weight: bold;font-size: 15px">정기적인 금액 후원</span>을 받아 운영비를 감내하려고 합니다.
                  </div>
                  <div v-if="item.id == '2'">
                    <span style="font-weight: bold;font-size: 15px">테마랩 사이트 사업 제안 혹은 인수</span>를 통하여 파트너쉽을 맺어 함께 성장 하기를 원하시는 기업체나 개인 사업자를 모십니다.
                  </div>
                  <div v-if="item.id == '3'">
                    Open API 를 활용한 <span style="font-weight: bold;font-size: 15px">자동 매매(본인 매매 개발 의뢰)에 관심이 있으신 분</span>들은 아래 메일 주소로 문의 부탁드립니다. (커스터 마이징 등 안내 예정)
                  </div>
              </v-timeline-item>
            </v-timeline>
            <div>
              위 내용들을 통해서도 진전되는 사항이 없을 시에는 사이트 유료 전환이나 폐쇄까지도 고려 중이니 테마랩을 사용하고 아껴주시는 많은 분들의 깊은 성원 부탁드리겠습니다.
            </div>
            <div>
              # 운영에 많은 도움이 되지는 않을 것 같습니다만, 사이트에 광고 배너가 최초로 노출이 되오니 가독성이 떨어지더라도 이해해주시면 감사하겠습니다.
            </div>
            <div>
              # <span style="font-weight: bold;font-size: 16px">문의 메일 : oo0722@naver.com</span>
            </div>
            <div>
              # 계좌번호 : 기업은행 409-128368-04-018 테마랩(정영철)
            </div>
          </v-card-text>
          <v-card-actions>
            <v-btn color="info" block @click="showNoticeDialog = false">닫기</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
</template>

<style>


    @media all and (min-width: 1264px) {
        .theme-layout {
            min-width: 236px;
        }
    }

    .v-tab {
      text-transform: none !important;
    }

    .header {
        font-size: 14px !important;
        padding: 4px 7px 4px 9px !important;
        justify-content: space-between;
    }

    .stock-area {
        display: flex;
        flex-direction: column;
        align-items: initial !important;
        min-height: 10px !important;
    }

    .stock {
        font-size: 13px;
        min-height: 24px !important;
        display: flex;
        align-content: space-between;
        //align-content: space-between;
    }

    .rate-info {
        font-size: 13px;
        display: flex;
        justify-content:space-between;
    }

    .header-avg {
        font-size: 12px;
        font-weight: normal;
    }

    .each {
        background-color: #b53f3f !important;
        color: #FFFFFF;
    }

    .covid {
        background-color: #227f98 !important;
        color: #FFFFFF;
    }

    .tech1 {
        background-color: #4e0f35 !important;
        color: #FFFFFF;
    }

    .tech2 {
        background-color: #4e0f35 !important;
        color: #FFFFFF;
    }

    .country {
        background-color: #4A86E8 !important;
        color: #FFFFFF;
    }

    .business {
        background-color: #103a1c !important;
        color: #FFFFFF;
    }

    .person {
        background-color: #8c7821 !important;
        color: #FFFFFF;
    }

    .company {
        background-color: #354c88 !important;
        color: #FFFFFF;
    }

    .rise {
        color: red;
    }

    .down {
        color: blue;
    }

    .rise2 {
        color: #f38b8b;
    }

    .name {
        padding: 0px;
    }

    .content-area {
        padding: 0px;
        justify-content: flex-end;
        flex-grow: 0.35 !important;
        text-align: right;
    }

    .rate {
        font-size: 14px;
    }

    .rise-enter-active {
        transition: all .3s ease;
    }
    .rise-leave-active {
        transition: all .8s cubic-bezier(1.0, 0.5, 0.8, 1.0);
    }
    .rise-enter, .rise-leave-to
        /* .slide-fade-leave-active for <2.1.8 */ {
        transition: opacity 0.8s linear;
        background-color: red;
        color: white;
    }

    .down-enter-active {
        transition: all .5s ease;
    }
    .down-leave-active {
        transition: all .8s cubic-bezier(1.0, 0.5, 0.8, 1.0);
    }
    .down-enter, .down-leave-to
        /* .slide-fade-leave-active for <2.1.8 */ {
        transition: opacity 0.8s linear;
        background-color: blue;
        color: white;
    }

    .ml-2, .mx-2 {
        margin-left: .5rem!important;
    }

    .badge {
        display: inline-block;
        padding: .25em .4em;
        font-size: 75%;
        font-weight: 700;
        line-height: 1;
        text-align: center;
        white-space: nowrap;
        vertical-align: baseline;
        border-radius: .25rem;
        -webkit-transition: color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,-webkit-box-shadow .15s ease-in-out;
        transition: color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,-webkit-box-shadow .15s ease-in-out;
        transition: color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out;
        transition: color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out,-webkit-box-shadow .15s ease-in-out;
    }

    .badge-success {
        color: #fff;
        background-color: #28a745;
    }

    .badge-danger {
        color: #fff;
        background-color: #dc3545;
    }

    .badge-info {
        color: #fff;
        background-color: #1775b8;
    }

    .badge-sort {
      color: #000000;
      background-color: #d1ef48;
    }

    .badge-filter {
      color: #000000;
      background-color: #FBC02D;
    }

    @media (max-width: 599px) {
      .flex-min {
        display: block !important;
      }
    }
</style>

<script>
    import Stock from "./Stock";
    import { v4 as uuidv4 } from 'uuid';
    import moment from "moment";
    import Calendar from "./Calendar";
    const ChosungSearch = require('hangul-chosung-search-js')

    export default {
        name: 'Themelap',
        components: {
          Calendar,
          Stock,
        },
        props: ['type', 'filter'],
        created() {
            this.debounceFn = this.lodash.debounce( () => {
              this.ranking();
            }, 800)
        },
        watch: {
            filter: function (val) {
              this.debounceFn();
            },
            sort: function (val) {
              localStorage.setItem('sort', val);
            },
            filters: {
              handler(val) {
                localStorage.setItem('filters', JSON.stringify(val));
              },
              deep: true
            }
        },
        sockets: {
            connect: function (response) {
                this.$socket.emit('connected', {
                    room: uuidv4()
                });
            },
            error: function() {
                console.log('socket error')
            },
            disconnect: function() {
                console.log('socket disconnected')
            },
            reconnect: function() {
                console.log('socket reconnect')
            },
            reconnect_attempt: function() {
                console.log('socket reconnect_attempt')
            },
            reconnecting: function() {
                console.log('socket reconnecting')
            },
            reconnect_error: function() {
                console.log('socket reconnect_error')
            },
            reconnect_failed: function() {
                console.log('socket reconnect_failed')
            },
            connect_error: function() {
                console.log('socket connect_error')
            },
            connect_timeout: function() {
                console.log('socket connect_timeout')
            },
            connecting: function() {
                console.log('socket connecting')
            },
            ping: function() {
                //console.log('socket ping')
            },
            pong: function() {
                //console.log('socket pong')
            }
        },
        mounted() {
            if (localStorage.getItem('sort')) {
              this.sort = localStorage.getItem('sort');
            }
            if (localStorage.getItem('filters')) {
              this.filters = JSON.parse(localStorage.getItem('filters'));
            }

            this.sockets.subscribe('theme', (data) => {
                const theme = [];
                if (Object.keys(data).length > 0) {
                    this.theme = theme.concat(data.each).concat(data.covid).concat(data.tech1).concat(data.tech2).concat(data.country).concat(data.company).concat(data.business).concat(data.person);
                    //this.theme = theme.concat(data.each);

                    this.theme.forEach((theme) => {
                        this.$set(this.theme, theme.header, theme);

                        theme.collapse = true;
                        theme.visible = true;
                        theme.stocks.forEach((stock) => {
                            this.$set(this.stocks, stock.name, stock);
                        })

                        theme.filterStocks = theme.stocks;
                    });
                    this.filterTheme = this.theme;
                }
                this.loaded = true;
            });

            this.sockets.subscribe('comment', (data) => {
              this.comment = data;
            });

            this.sockets.subscribe('stocks', (data) => {
                for (let key in data) {
                    this.updateStock(key, data[key]);
                }
                this.ranking();
            });

            this.sockets.subscribe('update', (data) => {
                for (let key in data) {
                    this.updateStock(key, data[key]);
                }
            });

            this.sockets.subscribe('market', (data) => {
                for (let key in data) {
                    if (this.market[key]) {
                        this.market[key]['rate'] = data[key]['rate'];
                    }
                }
            });

            this.sockets.subscribe('calendar', (data) => {
              const today = moment().format("YYYY-MM-DD");

              Object.keys(data).map((key) => {
                const contents = data[key];
                data[key] = {
                  title: contents.split('\n')[0],
                  contents: this.convertLinks(contents)
                }
              });

              //if (data[today]) {
              if (Object.keys(data).length > 0) {
                const firstData = data[Object.keys(data)[0]];
                this.todaySchedule = {
                  date: today,
                  title: firstData.title,
                  contents: firstData.contents
                }
              }
              this.calendar = data;
            });

            this.sockets.subscribe('dailyRanks', (data) => {
              this.dailyRanks = data;
            });

            setInterval(() => {
                this.ranking();
            }, 5000);
        },
        data: () => ({
            expand: false,
            showDialog: false,
            showConnectDialog: false,
            showCommentDialog: false,
            showSortDialog: false,
            showFilterDialog: false,
            showNoticeDialog: true,
            snackbar: true,
            noticeContents: [
              {
                id: 1,
                color: 'info',
                dotColor: 'green',
                icon: 'mdi-information',
              },
              {
                id: 2,
                color: 'info',
                dotColor: 'error',
                icon: 'mdi-alert-circle',
              },
              {
                id: 3,
                color: 'info',
                dotColor: 'blue',
                icon: 'mdi-alert-circle',
              },
            ],
            itemsPerPage: 10,
            theme: [],
            filterTheme: [],
            tab: null,
            tabs: [1, 2],
            sort: 'rate',
            sorts: [{
              text: '등락률',
              value: 'rate'
            }, {
              text: '거래대금',
              value: 'tradePrice'
            }],
            filters: {
              rate: -30,
              tradePrice: 0,
            },
            market: {
                'KOSPI': {
                    label: '코스피',
                    rate: 0
                },
                'KOSDAQ': {
                    label: '코스닥',
                    rate: 0
                },
                'DJI': {
                    label: '미국 다우',
                    rate: 0
                },
                'NAI': {
                    label: '미국 나스닥',
                    rate: 0
                },
                'NII': {
                    label: '일본 니케이',
                    rate: 0
                },
                'SHS': {
                    label: '중국 항생',
                    rate: 0
                },
                'FWB': {
                    label: '독일 DAX',
                    rate: 0
                }
            },
            stocks: {},
            loaded: false,
            comment: {},
            headerComment: '',
            themeComment: '',
            themeStockComment: [],
            todaySchedule: {},
            calendar: {},
            dailyRanks: {},
        }),
        methods: {
            getStockInfo: function (stockName) {
                if (this.stocks[stockName] && this.stocks[stockName].closePrice) {
                    return this.stocks[stockName];
                }
                return {
                    rate: 0,
                    closePrice: 0,
                    tradePrice: 0,
                    highRate: '-',
                    lowRate: '-',
                    openingRate: '-',
                    warning: '',
                };
            },
            updateStock: function (stockName, data) {
                this.stocks[stockName] = data;
            },
            ranking: function () {
                const rankTheme = [];

                // 랭킹
                this.theme.forEach((theme) => {
                    let sumRate = 0;
                    let availCount = 0;

                    let filterSearch = false;

                    if (this.filter.length > 0) {
                      if (ChosungSearch.isSearch(this.filter, theme.header)) {
                        filterSearch = true;
                      } else {
                        const isExist = theme.stocks.some(stock => {
                          return ChosungSearch.isSearch(this.filter, stock.name)
                        });
                        if (isExist) {
                          filterSearch = true;
                        }
                      }
                    }
                    const filterStocks = [];
                    theme.stocks.forEach(stock => {
                      const stockInfo = this.getStockInfo(stock.name) || { rate: 0 };
                      if (Number(stockInfo.rate) !== 0) {
                        sumRate += Number(stockInfo.rate);
                        availCount += 1;
                      }
                      Object.assign(stock, stockInfo);
                      stock.rate = Number(stockInfo.rate);
                      if (stock.highRate >= this.filters.rate && (stock.tradePrice / 100000000) >= this.filters.tradePrice) {
                        filterStocks.push(stock);
                      }
                    });
                    theme.filterStocks = filterStocks;
                    this.sort === 'rate' ? theme.filterStocks.sort(this.sortStock) : theme.filterStocks.sort(this.sortStockByTradePrice);
                    theme.avg = (availCount > 0) ? Number((sumRate / availCount).toFixed(2)) : 0;

                    if (theme.filterStocks.length > 0) {
                      if (this.filter.length > 0) {
                        if (filterSearch) {
                          rankTheme.push(Object.assign({}, theme));
                        }
                      } else {
                        rankTheme.push(Object.assign({}, theme));
                      }
                    }
                });
                rankTheme.sort(this.sortTheme).sort(this.sortHotTheme);
                this.filterTheme = rankTheme;
            },
            sortTheme: function custonSort(a, b) {
                if (a.avg === b.avg) {
                    return 0
                }
                return a.avg < b.avg ? 1 : -1;
            },
            sortHotTheme: function custonSort(a, b) {
                return (a.hot === b.hot)? 0 : a.hot? -1 : 1;
            },
            sortStock: function custonSort(a, b) {
                if (a.rate === b.rate) {
                    return 0
                }
                return a.rate < b.rate ? 1 : -1;
            },
            sortStockByTradePrice: function custonSort(a, b) {
              if (a.tradePrice === b.tradePrice) {
                return 0
              }
              return a.tradePrice < b.tradePrice ? 1 : -1;
            },
            numberWithCommas: function (x) {
                if (x !== undefined) {
                    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                }
                return 0;
            },
            onChange: function (item, header, isCollapse) {
                const findTheme = this.theme.find(theme => theme.header === item.header);
                if (findTheme) {
                  findTheme.collapse = isCollapse;
                }
                item.collapse = isCollapse;
            },
            getRateColor: function (rate) {
                if (rate > 0) {
                    return 'badge-danger'
                }
                return 'badge-info'
            },
            getThemeComment: function (header) {
              this.headerComment = header;
              this.themeStockComment = [];
              for (const key in this.comment[header]) {
                if (key === 'comment') {
                  this.themeComment = this.comment[header][key];
                } else {
                  const comment = this.comment[header][key];
                  this.themeStockComment.push({
                    stock: key,
                    comment: comment != null ? comment : '-'
                  })
                }
              }
              this.showCommentDialog = true;
            },
            getStockComment: function (header, stock) {
              if (this.comment[header] && this.comment[header][stock]) {
                return this.comment[header][stock];
              }
              return null;
            },
            openDialog: function () {
              this.showDialog = true
            },
            openSortDialog: function () {
              this.showSortDialog = true
            },
            openFilterDialog: function () {
              this.showFilterDialog = true
            },
            copyToClipboard: function (message) {
              const clipboardData = window.clipboardData || navigator.clipboard;
              clipboardData.writeText(message);
            },
            convertLinks: function( input ) {
              let text = input;
              const linksFound = text.match( /(?:www|https?)[^\s]+/g );
              const aLink = [];

              if ( linksFound != null ) {

                for ( let i=0; i<linksFound.length; i++ ) {
                  let replace = linksFound[i];
                  if ( !( linksFound[i].match( /(http(s?)):\/\// ) ) ) { replace = 'http://' + linksFound[i] }
                  let linkText = replace.split( '/' )[2];
                  if ( linkText.substring( 0, 3 ) == 'www' ) { linkText = linkText.replace( 'www.', '' ) }
                  if ( linkText.match( /youtu/ ) ) {

                    let youtubeID = replace.split( '/' ).slice(-1)[0];
                    aLink.push( '<div class="video-wrapper"><iframe src="https://www.youtube.com/embed/' + youtubeID + '" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe></div>' )
                  }
                  else if ( linkText.match( /vimeo/ ) ) {
                    let vimeoID = replace.split( '/' ).slice(-1)[0];
                    aLink.push( '<div class="video-wrapper"><iframe src="https://player.vimeo.com/video/' + vimeoID + '" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe></div>' )
                  }
                  else {
                    aLink.push( '<a href="' + replace + '" target="_blank">' + linkText + '</a>' );
                  }
                  text = text.split( linksFound[i] ).map(item => { return aLink[i].includes('iframe') ? item.trim() : item } ).join( aLink[i] );
                }
                return text;

              } else {
                return input;
              }
            }
        }
    }
</script>
